module.exports = __webpack_public_path__ + "img/bg1.aeec98ee.png";